<script>
  import Cookies from "js-cookie";

  export default {
    components: {
      BaseToast: () => import(
        /* webpackChunkName: "BaseToast" */ "@/components/partials/base-toast/Index.vue"
      ),
      AnnouncementPopup: () => import(
        /* webpackChunkName: "AnnouncementPopup" */ "@/components/release-notes/announcement/Index.vue"
      ),
      ReferFriendModal: () => import(
        /* webpackChunkName: "ReferFriendModal" */ "@/components/referral-and-loyalty-program/referral-modal/Index.vue"
      ),
      BaseChatNotifications: () => import(
        /* webpackChunkName: "BaseChatNotifications" */ "@/components/chat/notifications/Index.vue"
      ),
    },
    props: {},
    data() {
      return {};
    },

    computed: {
      isLoading() {
        return this.$store.state.Loader.isLoading;
      },

      user() {
        return this.$store.state.User.user;
      },

      showToast() {
        return this.$store.state.ResponseHandling.showToast;
      },

      toastContent() {
        return this.$store.state.ResponseHandling.toastContent;
      },

      referModal() {
        return this.$store.state.ReferralAndLoyaltyProgram.displayedReferModal;
      },
    },

    created() {
      let params = [];
      if (window.location.search) {
        params = window.location.search.split("&");
      }

      if (params && params.length && params.find((el) => el.includes("token"))) {
        const token = params.find((el) => el.includes("token")).split("=")[1];
        const expirationDate = params
          .find((el) => el.includes("expires"))
          .split("=")[1];

        Cookies.set(process.env.VUE_APP_TOKEN_KEY, token, {
          expires: +expirationDate,
          path: "/",
        });

        this.$router.replace({ name: "overview" });
      }
    },

    methods: {
    },
  };
</script>
<template>
  <div class="w-100">
    <Loader v-if="isLoading" />
    <transition name="fadeInDown">
      <base-toast v-if="showToast" :content="toastContent" />
    </transition>

    <BaseChatNotifications v-if="$route.name !== 'chat'" />

    <AnnouncementPopup v-if="user.persona !== 'partner' || !$store.getters['User/hasLimitedAccess']" />

    <transition name="fadeUp">
      <ReferFriendModal v-if="referModal" />
    </transition>
    <router-view />
  </div>
</template>
<style lang="sass" scoped></style>
